export default __webpack_public_path__ + "static/media/featuredRace.c0462dcd.png";